export enum InstrumentOfftimeReason {
  OFFTIME = 'Offtime',
  NOTBUYABLE = 'NotBuyable',
}
